import React, { useMemo, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import styled from 'styled-components'
import { useToasts } from 'react-toast-notifications'

import axiosInstance from '../../../../../services/config/AxiosIntance'

import TableRolesDisplay from '../../components/TableRolesDisplay'
import Loader from '../../../../../components/Loader'
import Flex from '../../../../../components/layouts/Flex'
import DashboardItemTitle from '../../components/DashboardItemTitle'
import NoData from '../../components/NoData'

import CSVDownloader from '../../../../../lib/CSVDownloader'

const TotalRolesPerRecruiter = () => {
  const { addToast } = useToasts()

  const filters = useSelector((state) => state.dashboard.filters)

  const [totalPage, setTotalPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [rowCount, setRowCount] = useState(0)

  const [loading, setLoading] = useState(false)
  const [tableData, setTableData] = useState([])
  const [groupedData, setGroupedData] = useState([])

  useEffect(() => {
    fetchData()
  }, [filters, currentPage, pageSize])

  const fetchData = async () => {
    try {
      setLoading(true)

      const queryFilter = {
        dates: filters.dates.toString(),
        recruiter_id: filters.recruiter_id,
        job_id: filters.job_id,
        company_id: filters.company_id,
        channel_id: filters.channel_id,
        stage_id: filters.stage_id,
      }
      const queryParams = new URLSearchParams(queryFilter).toString()

      const fetchedPageUrl = `/dashboard/recruiterRolesAssigned/fetchPage?${queryParams}&pageNumber=${currentPage}&pageSize=${pageSize}`

      const result = await axiosInstance.get(fetchedPageUrl)
      const fetchedData = result?.data?.data || []

      setTableData(fetchedData)
      setGroupedData(result?.data?.groupedData || [])
      setTotalPage(result?.data?.pagination?.pageCount)
      setRowCount(result?.data?.pagination?.rowCount)
      setCurrentPage(result?.data?.pagination?.page)
      setPageSize(result?.data?.pagination?.pageSize)
    } catch (error) {
      addToast('Something went wrong', {
        appearance: 'error',
        autoDismiss: true,
      })
    } finally {
      setLoading(false)
    }
  }

  const handleExport = async () => {
    try {
      const queryFilter = {
        dates: filters.dates.toString(),
        recruiter_id: filters.recruiter_id,
        job_id: filters.job_id,
        company_id: filters.company_id,
        channel_id: filters.channel_id,
        stage_id: filters.stage_id,
      }
      const queryParams = new URLSearchParams(queryFilter).toString()
      const url = `/dashboard/recruiterRolesAssigned/fetchAll?${queryParams}&pageNumber=${currentPage}&pageSize=${pageSize}`
      const result = await axiosInstance.get(url)

      const response = result?.data?.data.map((e) => ({
        'User Name': e.user_name,
        'Assigned Roles': e.job_title,
      }))

      CSVDownloader.downloadUnparsedCSV(response, 'Recruiter_Active_Roles.csv')
    } catch (error) {
      addToast('Something went wrong', {
        appearance: 'error',
        autoDismiss: true,
      })
    }
  }

  const tableColumns = useMemo(
    () => [
      {
        Header: 'User',
        accessor: 'user_name',
      },

      {
        Header: 'Active Roles Count',
        Aggregated: ({ cell, row }) => {
          return groupedData[row.values.user_name]?.length
        },
      },
      {
        Header: 'Vacancy',
        accessor: 'job_title',
      },
    ],
    [groupedData]
  )

  return (
    <StyledRecruiterRolesList>
      <Flex justify="space-between">
        <DashboardItemTitle title="Active Roles Assigned Per Recruiter" />
        <Flex gap="0.5rem">
          <ExportButton onClick={handleExport}>Export</ExportButton>
        </Flex>
      </Flex>

      {loading && <Loader />}

      {tableData?.length > 0 ? (
        <TableRolesDisplay
          height="100%"
          totalPage={totalPage}
          currentPage={currentPage}
          pageSize={pageSize}
          rowCount={rowCount}
          data={tableData}
          columns={tableColumns}
          setNewPageSize={setPageSize}
          setCurrentPage={setCurrentPage}
          fetchData={fetchData}
          onClick={() => null}
          groupedByCol={'user_name'}
        ></TableRolesDisplay>
      ) : (
        <NoData />
      )}
    </StyledRecruiterRolesList>
  )
}

export default TotalRolesPerRecruiter

const StyledRecruiterRolesList = styled.div`
  width: 100%;
  height: 100%;
`
const ExportButton = styled.button`
  padding: 0.35rem 0.65rem;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  text-overflow: ellipsis;
  overflow: hidden;
  background-color: black;
  color: white;
  border-radius: 100px;
  word-spacing: 3px;
`
